(function($, undefined) {
	
	'use strict';
	var formValidator;
	var notificationUtils;
	var messagesListContainer;

	var sendNewMessage = function(e) {
		var t = $(this);
		var form = t.closest('form');
		var receiverId;

		if (form.find('input[name=targetPersonId]').length !== 0) {
			receiverId = $('input[name=targetPersonId]', form).val();
		} else if (form.find('input[name=searcherId]').length !== 0) {
			receiverId = $('input[name=searcherId]', form).val();
		} else {
			receiverId = $('input[name=ids]', form).val();
		}
        if ($('input[name=ccId]', form).val()) {
            receiverId += ',' + $('input[name=ccId]', form).val();
        }

		formValidator.validateForm(form);
		if (form.hasClass('has-error')) {
			return false;
		}
		t.addClass('disabled');
        form.find('input[name="receiverIds"]').val(receiverId);
        setTimeout(function() {
            form.submit();
        }, 200);
	};
	
	$(window).ready(function () {
		formValidator = Fw.component.models().form;
		notificationUtils = Fw.component.models().notificationUtils;
		messagesListContainer = $('.messages-list')[0];

		$('.send-new-message-btn').click(sendNewMessage);
		
		if (messagesListContainer) {
			messagesListContainer.scrollTop = messagesListContainer.scrollHeight;	
		}
	});
	
})(jQuery);
